// extracted by mini-css-extract-plugin
export default {"animal_id":"MarkAsDeadForm_animal_id__yG2qL","error":"MarkAsDeadForm_error__sW1is","spin":"MarkAsDeadForm_spin__RW++5"};